import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any[],filterString:string,propName:string): any[] {
    const Result=[]

    if(value.length ==0 || filterString=='' || propName==''){
      return value
    }

    for(const item in value){
      if(value[item][propName].toLowerCase().includes(filterString.toLowerCase()))
        Result.push(value[item])
    }

    return Result
  }
}
